import { ImageId, SessionId } from './Session';

export const IMAGES_SOURCE_ID = 'images';

export interface ImageProperties {
    id: ImageId;
    sessionId: SessionId;
    imageIndex: number;
    cumulStartSession: number;
    roadName?: string;
    roadCumul?: number;
    grade?: number;
    [key: `grade.${string}`]: number;
}

export const ROADS_SOURCE_ID = 'roads';

export interface RoadsProperties {
    id: string;
    name: string;
}

export const WIDTHS_SOURCE_ID = 'widths';

export interface WidthProperties {
    id: string;
    sessionId: SessionId;
    rubricCode: string;
    imageIndex: number;
    imageCumulStart: string;
    measuredWidth: number;
    sectionSurface?: number;
    totalSurface?: number;
    landmarkStartLabel: string;
    landmarkStartSign: '+' | '-';
    landmarkStartAbd: string;
}

export const DEGRADATIONS_SOURCE_ID = 'degradations';

export interface DegradationProperties {
    id: string;
    sessionId: SessionId;
    rubricCode: string;
    color: string;
    referenceName: string;
    imageIndex: number | null;
    imageCumulStart: string | null;
}
